import { CARD_SHADOW, COLORS } from '../IndividualPlan/tokens';

export const REPORT = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  faint: '#7F7F99',
  navy: COLORS.navy,
  divider: COLORS.divider,
  grid: '#E3E3E8',
  hatch: '#C1C1CD',
  hatchSwatch: 'repeating-linear-gradient(135deg, #FFFFFF 0 1px, #C1C1CD 1px 2.83px)',
  sheet: { width: 816, height: 1056, padding: 48, inner: 720 },
  screenBg: COLORS.bg,
  cardShadow: CARD_SHADOW,
  font: '"Nunito", system-ui, sans-serif',
  chromeFont: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
} as const;
